import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from "@faire/web/ui/hooks/useState";
import { useCallback } from "react";
export var useAsyncDataStatus = function useAsyncDataStatus() {
  var _useState = useState("not-requested-yet"),
    _useState2 = _slicedToArray(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];
  var setAsInProgress = useCallback(function () {
    return setStatus("in-progress");
  }, []);
  var setAsComplete = useCallback(function () {
    return setStatus("complete");
  }, []);
  var setAsNotRequestedYet = useCallback(function () {
    return setStatus("not-requested-yet");
  }, []);
  var asyncDataInProgress = status === "in-progress";
  var asyncDataComplete = status === "complete";
  return {
    asyncDataInProgress: asyncDataInProgress,
    asyncDataComplete: asyncDataComplete,
    setAsInProgress: setAsInProgress,
    setAsComplete: setAsComplete,
    setAsNotRequestedYet: setAsNotRequestedYet
  };
};